module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "form",
    staticClass: "box-body"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "overlay",
    staticStyle: {
      "position": "absolute",
      "top": "0px",
      "left": "0px",
      "width": "100%",
      "height": "100%",
      "display": "block"
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  })]), _vm._v(" "), (!_vm.showgrid) ? _c('div', {
    staticClass: "form-horizontal row well well-sm no-shadow animated fadeInDownOutUp",
    staticStyle: {
      "margin": "0px"
    },
    attrs: {
      "name": "frmAddAt"
    }
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "titulo-periodo"
  }, [_vm._v("\r\n            Justificativa (Será salvo em Alterações no Projeto)\r\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('data')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-2",
    attrs: {
      "for": "data"
    }
  }, [_vm._v("Data:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [(_vm.alteracao.id) ? _c('div', [_c('datepicker', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    ref: "data",
    attrs: {
      "name": "data",
      "input-class": "form-control",
      "language": _vm.$datePickerPtBR,
      "maxlength": "20",
      "placeholder": "__ /__ /____",
      "highlighted": _vm.highlighted,
      "disabled": "",
      "format": "dd/MM/yyyy"
    },
    model: {
      value: (_vm.alteracao.dt_registro),
      callback: function($$v) {
        _vm.$set(_vm.alteracao, "dt_registro", $$v)
      },
      expression: "alteracao.dt_registro"
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.alteracao.id) ? _c('div', [_c('datepicker', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    ref: "data",
    attrs: {
      "name": "data",
      "input-class": "form-control datepicker",
      "language": _vm.$datePickerPtBR,
      "maxlength": "20",
      "placeholder": "__ /__ /____",
      "highlighted": _vm.highlighted,
      "disabled": "",
      "format": "dd/MM/yyyy"
    },
    model: {
      value: (_vm.alteracao.dt_registro),
      callback: function($$v) {
        _vm.$set(_vm.alteracao, "dt_registro", $$v)
      },
      expression: "alteracao.dt_registro"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.errors.first('data')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('data')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('tipo')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-2",
    attrs: {
      "for": "tipo"
    }
  }, [_vm._v("Tipo:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('div', [_c('multiselect', {
    attrs: {
      "options": _vm.tipos,
      "multiple": false,
      "close-on-select": true,
      "clear-on-select": true,
      "hide-selected": false,
      "preserve-search": true,
      "placeholder": "Selecione um Tipo de Alteração",
      "track-by": "codigo",
      "custom-label": _vm.etiquetaTipos,
      "preselect-first": false,
      "selectLabel": "",
      "deselectLabel": "",
      "selectedLabel": "Selecionado",
      "name": "tipo",
      "disabled": "",
      "data-vv-as": "Tipo de alteração"
    },
    on: {
      "select": function($event) {
        return _vm.onSelect($event, _vm.alteracao.tipo)
      }
    },
    model: {
      value: (_vm.alteracao.tipo),
      callback: function($$v) {
        _vm.$set(_vm.alteracao, "tipo", $$v)
      },
      expression: "alteracao.tipo"
    }
  }, [_c('span', {
    attrs: {
      "slot": "noResult"
    },
    slot: "noResult"
  }, [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("Nenhum registro localizado!")])], 1)])], 1), _vm._v(" "), (_vm.errors.first('tipo')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('tipo')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('detalhamento')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-2",
    attrs: {
      "for": "detalhamento"
    }
  }, [_vm._v("Detalhe:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('div', [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detalhamentoAnt),
      expression: "detalhamentoAnt"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": _vm.place,
      "name": "detalhamento",
      "type": "text",
      "maxlength": "1000",
      "cols": "10",
      "rows": "8"
    },
    domProps: {
      "value": (_vm.detalhamentoAnt)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.detalhamentoAnt = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.errors.first('detalhamento')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('detalhamento')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('motivo')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-2",
    attrs: {
      "for": "motivo"
    }
  }, [_vm._v("Motivo:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('multiselect', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "options": _vm.motivos,
      "multiple": false,
      "close-on-select": true,
      "clear-on-select": true,
      "hide-selected": false,
      "preserve-search": true,
      "placeholder": "Selecione um Motivo",
      "track-by": "codigo",
      "custom-label": _vm.etiquetaMotivos,
      "preselect-first": false,
      "selectLabel": "",
      "deselectLabel": "",
      "selectedLabel": "Selecionado",
      "name": "tipo",
      "data-vv-as": "Motivo da alteração"
    },
    model: {
      value: (_vm.alteracao.motivo),
      callback: function($$v) {
        _vm.$set(_vm.alteracao, "motivo", $$v)
      },
      expression: "alteracao.motivo"
    }
  }, [_c('span', {
    attrs: {
      "slot": "noResult"
    },
    slot: "noResult"
  }, [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("Nenhum registro localizado!")])], 1)])], 1), _vm._v(" "), (_vm.errors.first('motivo')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('motivo')))]) : _vm._e()]), _vm._v(" "), (_vm.alteracao.responsavel.ds_nome_usuario) ? _c('div', {
    staticClass: "form-group required-field"
  }, [_c('label', {
    staticClass: "control-label col-md-2",
    attrs: {
      "for": "responsavel"
    }
  }, [_vm._v("Responsável:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.alteracao.responsavel.ds_nome_usuario),
      expression: "alteracao.responsavel.ds_nome_usuario"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "responsavel",
      "type": "text",
      "maxlength": "255",
      "disabled": true
    },
    domProps: {
      "value": (_vm.alteracao.responsavel.ds_nome_usuario)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.alteracao.responsavel, "ds_nome_usuario", $event.target.value)
      }
    }
  })])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.first('anexo')
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('div', [_vm._v("\r\n                Para realizar a alteração do prazo, os documentos "), _c('strong', [_vm._v("obrigatórios")]), _vm._v(" devem ser anexados:\r\n                "), _vm._m(1), _vm._v(" "), _c('upload-documentos-php-novo', {
    attrs: {
      "propDocumentos": _vm.alteracao.documentos,
      "documentTypes": '',
      "disable": '',
      "localUso": 'ALTERACAO_PERIODO_EXECUCAO',
      "salvouOK": _vm.salvouOK
    }
  })], 1)]), _vm._v(" "), (_vm.errors.first('anexo')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('anexo')))]) : _vm._e()]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    staticStyle: {
      "margin-bottom": "0"
    }
  }, [_c('div', {
    staticClass: "col-md-8 col-md-offset-2"
  }, [_c('g-button-ujarak', {
    attrs: {
      "color": "success",
      "size": "button--size-ss"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.onAdd(_vm.frmAddAt)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Concluir")]), _vm._v(" "), _c('g-button-ujarak', {
    attrs: {
      "color": "warning",
      "size": "button--size-ss"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.cancelar(_vm.editando)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-times-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Cancelar")])], 1)])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "control-label col-md-2",
    attrs: {
      "for": "responsavel"
    }
  }, [_vm._v("Anexos: "), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ol', {
    attrs: {
      "type": "1"
    }
  }, [_c('li', [_vm._v("Súmula ou Nota Técnica.")]), _vm._v(" "), _c('li', [_vm._v("Termo Aditivo assinado, quando o "), _c('strong', [_vm._v("prazo de vigência")]), _vm._v(" for alterado.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('br'), _c('br')])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-314e92ea!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/projetos/AlteracoesPeriodoExecucao.vue
// module id = 1903
// module chunks = 1